import {Injectable} from "@angular/core";
import {Supplier} from "../../../shared/view-model/crm/supplier.type";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {fetchSuppliersQuery, SupplierService} from "../../../crm/services/supplier/supplier.service";
import {Observable} from "rxjs/Observable";
import {NgRedux} from "@angular-redux/store";
import {Apollo} from "apollo-angular";
import {IAppState} from "../../../shared/redux-store/store";
import {map} from "rxjs/operators";

@Injectable()
export class SupplierResolverService implements Resolve<Supplier | Supplier[]> {

  constructor(private supplierService: SupplierService, private apollo: Apollo, private ngRx: NgRedux<IAppState>) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Supplier | Supplier[]> | Promise<Supplier | Supplier[]> | Supplier[] | Supplier {
    return new Observable((obs: any) => {
      this.apollo.query({
        query: fetchSuppliersQuery,
        variables: {
          AU: this.ngRx.getState().session.activeAdminUnit //this.adminUnitCuid$
        }
      })
        .pipe(map((res: any) => {
          return res.data.fetchSuppliers;
        }))
        .subscribe((suppliers: any) => {
          obs.next(suppliers);
          obs.complete();
        });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/services/resolvers/supplier-resolver.service.ts